
const SessionKey = Object.freeze({
    sessionID:"sessionID",
    x_csrf_token_key_ : 'x_csrf_token_key_',
    x_csrf_token_client : 'x_csrf_token_client'
});


export default SessionKey;
